import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger);

export default (() => {
  gsap.to('#app', {
    opacity: 1,
    duration: 1,
  });

  const titles = $('h1').not('.teaser-post h1, .teaser-post h2, .teaser-post h3, .teaser-post h4')
  titles.map(function() {
    gsap.from(this, {
      scrollTrigger: this,
      opacity: 0,
      y: 30,
      duration: 0.5,
    });
  })

  const teasers = $('.teaser-post, .wp-block-image, .wp-block-button, .swiper-slide');

  teasers.each(function() {
    gsap.from(this, {
      scrollTrigger: this,
      opacity: 0,
      y: 30,
      duration: 0.5,
    });
  });
  

})();



// WEBPACK FOOTER //
// ./scripts/layout/animations.js